import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-check-circle',
  standalone: true,
  templateUrl: './rt-icon-check-circle.component.html',
  styleUrls: ['./rt-icon-check-circle.component.scss']
})
export class RtIconCheckCircleComponent {
  @Input() width: number | string = 24;
  @Input() height: number | string = 24;
}
